import { useTranslation } from 'react-i18next';
import 'flag-icons/css/flag-icons.min.css';
import './LanguageSelector.css';

const LANGUAGES = [
  { code: 'es', label: 'ES', flag: 'es' },
  { code: 'en', label: 'EN', flag: 'gb' },
  { code: 'fr', label: 'FR', flag: 'fr' },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2);

  return (
    <div className="lang-selector">
      {LANGUAGES.map(lang => (
        <button
          key={lang.code}
          className={`lang-btn ${current === lang.code ? 'active' : ''}`}
          onClick={() => i18n.changeLanguage(lang.code)}
          title={lang.label}
        >
          <span className={`fi fi-${lang.flag}`} />
          <span className="lang-label">{lang.label}</span>
        </button>
      ))}
    </div>
  );
}